import { useEffect, useState } from 'react';

/**
 * 计算实际渲染高度的hook
 * @param designHeight 设计稿中的高度（px）
 * @param designWidth 设计稿的基准宽度（默认375px）
 * @returns 当前设备上实际渲染的高度（px）
 */
export const useTailwindRealHeight = (designHeight: number, designWidth: number = 375): number => {
  const [realHeight, setRealHeight] = useState<number>(designHeight);

  useEffect(() => {
    // 获取当前设备宽度
    const currentDeviceWidth = window.innerWidth;

    // 计算比例系数
    const ratio = currentDeviceWidth / designWidth;

    // 计算实际渲染高度
    const calculatedHeight = Math.round(designHeight * ratio);

    setRealHeight(calculatedHeight);

    // 监听窗口大小变化，动态更新高度
    const handleResize = () => {
      const newDeviceWidth = window.innerWidth;
      const newRatio = newDeviceWidth / designWidth;
      const newCalculatedHeight = Math.round(designHeight * newRatio);
      setRealHeight(newCalculatedHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [designHeight, designWidth]);

  return realHeight;
};
